/**
 * Program Cards 1045 — BDU Other Specialisations
 * Left-aligned eyebrow + heading + rule, then a horizontal card rail.
 */

export const PROGRAM_CARDS_1045_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Other specialisation cards",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_title: "Economics",
    meta_parent_title: "Online MA",
    meta_description: "",
    meta_duration: "2 Years",
    meta_image: "",
    meta_alt_image: "",
    meta_url: "",
    meta_priority: 1,
    meta_status: true,
  },

  PROGRAM_CARDS_FIELDS_CONFIG: [
    {
      fieldName: "pre_title",
      label: "Eyebrow line",
      value: "Didn't find what you need?",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Didn't find what you need?",
    },
    {
      fieldName: "pre_title_color",
      label: "Eyebrow colour",
      value: "#222023",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#222023",
    },
    {
      fieldName: "title",
      label: "Heading",
      value: "Explore other Specialisation Courses",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Explore other Specialisation Courses",
    },
    {
      fieldName: "title_text_color",
      label: "Heading colour",
      value: "#222023",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#222023",
    },
    {
      fieldName: "gradient_color_1",
      label: "Rule under heading — start",
      value: "#FF0013",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FF0013",
    },
    {
      fieldName: "gradient_color_2",
      label: "Rule under heading — end",
      value: "#990013",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#990013",
    },
    {
      fieldName: "card_background_color",
      label: "Card tint over the image",
      value: "#222023A1",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#222023A1",
    },
    {
      fieldName: "cta_text",
      label: "Card CTA label",
      value: "Know more",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Know more",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Card background image",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload card artwork",
      defaultValue: "",
    },
    {
      header: "Image alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Economics",
      defaultValue: "",
    },
    {
      header: "Parent programme (set to render as a specialisation)",
      fieldName: "meta_parent_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Online MA — leave empty for a standalone programme",
      defaultValue: "",
    },
    {
      header: "Description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Duration",
      fieldName: "meta_duration",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 2 Years",
      defaultValue: "",
    },
    {
      header: "Card URL",
      fieldName: "meta_url",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/online-ma/economics",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
